import { useEffect } from "react";
import axios from "axios";
import { useZxing } from "react-zxing";
import { useUser } from "../../config/userProvider";
import { apiurl } from "../../config/config";

const BarcodeScanner = ({
  barCodeResult,
  setBarCodeResult,
  setCombinedData,
  data,
}) => {
  const { ref } = useZxing({
    onDecodeResult(barCodeResult) {
      setBarCodeResult(barCodeResult.getText());
    },
  });

  const { userData } = useUser();

  useEffect(() => {
    if (barCodeResult) {
      // const matchBarcode = data.find((item) => item?.barcode === barCodeResult);


      let config = {
        method: "get",
        maxBodyLength: Infinity,
        url: `${apiurl}/admin/v1/product/barcode?vendorObjId=${userData?.vendorDetails?.vendorObjId}&barcode=${barCodeResult}`,
        headers: {},
      };

      axios
        .request(config)
        .then((response) => {
          setCombinedData((prevData) => [...prevData, response.data.data]);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [barCodeResult, userData?.vendorDetails?.vendorObjId, setCombinedData]);

  return (
    <>
      {/* <div
        className=" mt-[20%] border-white rounded-lg overflow-hidden p-5"
        style={{ borderWidth: 4 }}
      > */}
      <div className="rounded-lg overflow-hidden">
        <video ref={ref} height="200px" />
      </div>
      {/* </div> */}
      {/* {barCodeResult && (
        <p className=" bg-white w-10/12 p-2 absolute top-1/2 left-1/2 -translate-x-1/2  -transition-y-1/2">
          <div className="font-semibold text-xl shadow-md text-center">
            {barCodeResult}
          </div>
          <div className="font-semibold text-xl shadow-md text-center">
            {"["}
            {barcodeData} {"]"}
          </div>
        </p>
      )} */}
    </>
  );
};
export default BarcodeScanner;
